import { Dialog } from "@mui/material";
import { useState } from "react";
import DialogContentSelectGeneric from "./DialogsContents/DialogContentGeneric";
import MultipleChipsField from "../BaseInputs/MultipleChipsField";
import {IUnidadeMedida} from "../../types/api/estoque/pesquisar-unidade-medida";

export default function SelectUnidadeMedida({
                                                value,
                                                onChange,
                                                label = "Unidades de Medida",
                                                required = false,
                                                error = false,
                                                multiple = true,
                                            }: SelectUnidadeMedidaProps) {
    const [openModal, setOpenModal] = useState(false);

    const handleClose = () => setOpenModal(false);

    return (
        <>
            <MultipleChipsField
                value={value}
                label={label}
                required={required}
                formatChipLabel={(item) =>
                    item
                        ? `${item.sigla} - ${item.nome}`
                        : ""
                }
                onClick={() => setOpenModal(true)}
                error={!!error}
                helperText={error ? "Campo obrigatório" : ""}
            />

            {openModal && (
                <Dialog fullWidth maxWidth="sm" open={openModal} onClose={handleClose}>
                    <DialogContentSelectGeneric
                        {...{ handleClose }}
                        multiple={multiple}
                        title="Selecionar unidade de medida"
                        queryPath="estoque/pesquisar-unidade-medida"
                        getItemKey={(item) => item?.sigla ?? ""}
                        getItemLabel={(item) =>
                            item
                                ? `${item.sigla} - ${item.nome}`
                                : ""
                        }
                        defaultValue={value ?? []}
                        onChange={(newValue) => {
                            onChange(newValue as IUnidadeMedida[]);
                            handleClose();
                        }}
                    />
                </Dialog>
            )}
        </>
    );
}

interface SelectUnidadeMedidaProps {
    value: IUnidadeMedida[] | null;
    onChange: (arg: IUnidadeMedida[] | null) => void;
    required?: boolean;
    error?: boolean;
    label?: string;
    multiple?: boolean;
}